<template>
    <div class="networks-container">
        <b-row>
            <b-col
                v-for="(valuers, network) in valuersByNetwork"
                :key="network"
                :class="{
                    'networks-column': true,
                    'background-gray': shouldApplyBackgroundColor(network),
                }"
            >
                <div class="network-title">
                    {{ $t(`values.table.${valuers.string}`) }}
                </div>
                <div class="networks-list scroll">
                    <div :key="valuer.id" v-for="valuer in valuers" class="valuer">
                        <avatar :size="35" class="valuer-avatar" :src="valuer.picture" :username="valuer.name" />
                        <div class="valuer-name">{{ valuer.name }}</div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import Avatar from 'vue-avatar'
import { groupBy, sortBy } from 'lodash'
import { orderedNetworksMixin } from '@/mixins'

export default {
    components: { Avatar },
    mixins: [orderedNetworksMixin],
    props: {
        valuers: {
            type: Array,
            required: true,
        },
    },
    computed: {
        valuersByNetwork() {
            let groups = groupBy(this.valuers, 'type')
            let ordered = this.orderNetworks(groups)
            let sortered = sortBy(ordered, 'order')
            return sortered
        },
    },
    methods: {
        shouldApplyBackgroundColor(network) {
            const networks = Object.keys(this.valuersByNetwork)
            const index = networks.indexOf(network)
            return index % 2 != 0
        },
    },
}
</script>
<style lang="scss" scoped>
.title {
    font-weight: 700;
}

.background-gray {
    background-color: #f9f9f9;
}

.networks-container {
    color: #6e6e6e;
    padding: 25px 30px;
    border: 1px solid #ebebeb;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.24);

    .container-title {
        @extend .title;
        font-size: 18px;
        margin-bottom: 10px;
    }

    .networks-column {
        padding: 16px;
        margin-right: 12px;

        .network-title {
            @extend .title;
            font-size: 16px;
            margin-bottom: 10px;
        }

        .networks-list {
            max-height: 274px;

            .valuer {
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                .valuer-avatar {
                    margin-right: 10px;
                }

                .valuer-name {
                    @extend .title;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
